module.exports = __webpack_public_path__ + "static/img/ikonaPaint-OFF.20e75e01.png";